<ng-template [ngIf]="element.lavoratore.nominativo">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Cognome e Nome'" [valueInput]="element.lavoratore?.nominativo"></div>
</ng-template>
<ng-template [ngIf]="!element.lavoratore.nominativo && element.lavoratore.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Cognome e Nome'" [valueInput]="element.lavoratore?.cognome + ' ' + element.lavoratore?.nome"></div>
</ng-template>
<ng-template [ngIf]="!element.lavoratore.nominativo && element.lavoratore.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Cognome e Nome'" [valueInput]="element.lavoratore?.ragioneSociale"></div>
</ng-template>

<div labelTextInput class="col-sm-4 bloccodati"
     [typeLabel]="'text'" [labelInput]="'Patologia'"
     [valueInput]="element.patologia"></div>
<div labelTextInput class="col-sm-4 bloccodati"
     [typeLabel]="'percentuale'" [labelInput]="'% invalidità'"
     [valueInput]="element.percentualeInvalidita"></div>
